import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, debounceTime } from 'rxjs';
import { Area } from 'src/app/models/area.model';
import { ChecklistItem } from 'src/app/models/checklist-item.model';
import { SortByOptions } from 'src/app/models/customer.model';
import { KeyValueItem } from 'src/app/models/keyValueItem.model';
import { Region } from 'src/app/models/region.model';
import { SiteVerificationList, SiteVerificationStatus, SiteVerificationsStats } from 'src/app/models/siteVerification.model';
import { AreaService } from 'src/app/services/area.service';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { RegionService } from 'src/app/services/region.service';
import { SiteVerificationService } from 'src/app/services/siteVerification.service';
import { TariffService } from 'src/app/services/tariff.service';
import { TranslationService } from 'src/app/services/translation.service';
import { GeographicalRegion, GeographicalRegionService, SubGeographicalRegion, SubGeographicalRegionService } from 'shared-lib';

@Component({
  selector: 'app-site-verification-list',
  templateUrl: './site-verification-list.component.html',
  styleUrls: ['./site-verification-list.component.scss']
})
export class SiteVerificationListComponent implements OnInit {
  dateFrom: string;
  dateTo: string;
  mapSortBy: Record<number, any> = {
    [SortByOptions.NEWEST]: { label: 'Newest', arrow: 'no', translation: 'COMMON.SORT_BY.NEWEST' },
    [SortByOptions.OLDEST]: { label: 'Oldest', arrow: 'no', translation: 'COMMON.SORT_BY.OLDEST' },
  };
  sortByValue: SortByOptions = SortByOptions.NEWEST;
  tag?: number;
  tagOptions = [
    { name: 'Existing', value: 0, translation: 'COMMON.TAG.EXISTING' },
    { name: 'Onboard', value: 1, translation: 'COMMON.TAG.ONBOARD' },
  ];
  statusItems = [
    { id: SiteVerificationStatus.New, name: 'New', checked: false },
    { id: SiteVerificationStatus.Assigned, name: 'Assigned', checked: false },
    { id: SiteVerificationStatus.Submited, name: 'Submitted', checked: false },
    { id: SiteVerificationStatus.Approved, name: 'Approved', checked: false },
    { id: SiteVerificationStatus.Rejected, name: 'Rejected', checked: false },
  ];
  selectedStatuses: number[] = [];
  showSortBy: boolean = false;

  stats : SiteVerificationsStats={};
  sortByOptions = SortByOptions;
  sortByLabelValue: any = this.mapSortBy[SortByOptions.NEWEST];
  pageSize: number = 10;
  currentPage: number = 1;
  searchText: string = '';
  searchTextUpdate = new Subject<string>();
  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');
  clicked: boolean = false;
  regions: Region[] = [];
  areas: Area[] = [];
  allAreas: Area[] = [];
  geographicalRegions: (GeographicalRegion & { checked?: boolean })[] = [];
  allSubGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  subGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  selectedFilters: ChecklistItem[] = [];
  siteVerifications: SiteVerificationList[] = [];
  count: number = 0;
  selectedAreas: number[] = [];
  selectedRegions: number[] = [];
  selectedSubGeographicalRegions: number[] = [];

  hasCimDataIntegration: boolean = false;
  constructor(
    private toastr: ToastrService,
    private commonService: CommonService,
    private translationService: TranslationService,
    private regionService: RegionService,
    private areaService: AreaService,
    public authService: AuthService,
    private tariffService: TariffService,
    private route: ActivatedRoute,
    private siteVerificationService:SiteVerificationService,
    private router:Router,
    private geographicalRegionService: GeographicalRegionService,
    private subGeographicalRegionService: SubGeographicalRegionService) {
    
  }

  ngOnInit(): void {
    this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
    if (this.hasCimDataIntegration) {
      this.getGeographicalRegions();
    } else {
      this.getRegions();
      this.getAreas();
    }
    this.getData();
    this.getStats();
    this.searchTextUpdate.pipe(debounceTime(500)).subscribe((value) => {
      if (this.searchText == '') this.search();
    });
  }
  private getData(): void {
    this.getSiteVerificationStats();
    this.reloadTable();
  }  
  getSiteVerificationStats(){}
  search() {
    this.reloadTable(1);
  }
  pageChange(value: any) {
    this.currentPage = value;
    this.reloadTable();
  }
  selectTag(e: any) {
    if (e.target.value != '') {
      this.tag = parseInt(e.target.value) ;
    } else {
      this.tag = undefined;
    }
 
    this.createFilterCards();
    this.reloadTable(1);
  }
  setFilterStorage(){}
  datesValid() {
    if (this.dateFrom && this.dateTo) {
        const valid: boolean = new Date(this.dateFrom).getTime() < new Date(`${this.dateTo.toString()}T23:59:59`).getTime();
        return valid;
    }
    return false;
  }
  selectRegion(e: any) {
    //list of areas for selected regions
    this.areas= this.allAreas.filter(area => this.regions.some(region => region.id == area.regionId && region.checked));
    this.allAreas.forEach(area => { 
      if (!this.areas.some(a => a.id === area.id)) {
        area.checked = false; //uncheck areas for unchecked regions
      }
    });

    this.createFilterCards();
  }
  selectVerification(id: number) {
    this.router.navigate([`work-orders/verification-details/${id}`])
    this.setFilterStorage();
  }
  private getRegions() {
    this.regionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data;
          this.createFilterCards();
          // this.getAreas();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getAreas() {
    this.areaService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allAreas = responseData.data;
          this.createFilterCards();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  private getGeographicalRegions() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response: { body: any; }) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geographicalRegions = responseData.data;
          this.getSubGeographicalRegions();
        }
      },
      error: (_: any) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getSubGeographicalRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response: { body: any; }) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allSubGeographicalRegions = responseData.data;
          this.subGeographicalRegions = this.allSubGeographicalRegions.filter(
            (sub) =>
              this.geographicalRegions.some(
                (region) =>
                  region.id == sub.geographicalRegion.id && region.checked
              )
          );
          this.createFilterCards();
        }
      },
      error: (_: any) => {
        this.toastr.error('Error occured');
      },
    });
  }

  selectGeographicalRegion(e: any) {
    this.subGeographicalRegions = this.allSubGeographicalRegions.filter((sub) =>
      this.geographicalRegions.some(
        (region) => region.id == sub.geographicalRegion.id && region.checked
      )
    );
    this.allSubGeographicalRegions.forEach((sub) => {
      if (!this.subGeographicalRegions.some((s) => s.id === sub.id)) {
        sub.checked = false;
      }
    });
    this.createFilterCards();
  }

  reloadTable(page: any = null) {
    if (page) this.currentPage = page;
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
        count: this.count
      },
      filterParams: this.getFilterObject()
    };
    this.getAll(obj);
  }
  selectArea(e: any) {
    this.createFilterCards();
  }
  selectStatus(e: any) {
    this.createFilterCards();
  }
  resetFilter(e: any) {
    this.selectedFilters = [];
    this.tag = undefined;
    this.regions = this.regions.map(region => ({ ...region, checked: false }));
    this.regions = [...this.regions];

    this.areas = this.areas.map(area => ({ ...area, checked: false }));
    this.areas = [...this.areas];

    this.geographicalRegions = this.geographicalRegions.map(region => ({ ...region, checked: false }));
    this.allSubGeographicalRegions.forEach((sub) => (sub.checked = false));
    this.subGeographicalRegions = [];

    this.statusItems = this.statusItems.map(item => ({ ...item, checked: false }));
    this.statusItems = [...this.statusItems];

    this.selectedStatuses = [];
    this.selectedAreas = [];
    this.selectedRegions = [];
    this.selectedSubGeographicalRegions = [];

    this.reloadTable(1);
  }
  isAllCheckBoxChecked() {
    return false;
  }
  checkAllCheckBox(event: any) {}
  getFilterObject() {
    let obj = {
      sortBy: this.sortByValue,
      search: this.searchText,
      dateFrom: this.dateFrom ? this.dateFrom : null,
      dateTo: this.dateTo ? `${this.dateTo}T23:59:59` : null,
      statuses: this.selectedStatuses.length > 0 ? this.selectedStatuses : null,
      tag: this.tag,
      selectedAreas: this.selectedAreas.length > 0 ? this.selectedAreas : null,
      selectedRegions:
        this.selectedRegions.length > 0 ? this.selectedRegions : null,
      selectedSubGeographicalIds:
        this.selectedSubGeographicalRegions.length > 0
          ? this.selectedSubGeographicalRegions
          : null,
    };
    return obj;
  }
  private getStats() {
    this.siteVerificationService.getStats().subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          this.stats = data.data;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  sortBy(option: SortByOptions) {
    this.sortByValue = option;
    this.sortByLabelValue = this.mapSortBy[option];
    this.reloadTable();
  }
  private getAll(obj: any) {
 
    this.siteVerificationService.getAll(obj).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.siteVerifications = responseData.data.data;
          
          this.count = responseData.data.count ?? this.count;
          if (responseData.message != '') {
            this.toastr.warning(responseData.message);
          }
        } else if (response?.status == 204) {
          this.toastr.warning('No content');
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  removeFilter(item: ChecklistItem) {
    if (item.property == this.buName) {
      this.regions.forEach((region) => {
        if (region.name === item.selectedValue) {
          region.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == this.utName) {
      this.areas.forEach((area) => {
        if (area.name === item.selectedValue) {
          area.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == 'Status') {
      this.statusItems.forEach((s) => {
        if (s.name === item.selectedValue) {
          s.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == 'Geographical Region') {
      this.geographicalRegions.forEach((region) => {
        if (region.name === item.selectedValue) {
          region.checked = false;
        }
      });
      this.selectGeographicalRegion(item);
      this.clicked = !this.clicked;
    } else if (item.property == 'Sub Geographical Region') {
      this.subGeographicalRegions.forEach((sub) => {
        if (sub.name === item.selectedValue) {
          sub.checked = false;
        }
      });
      this.clicked = !this.clicked;
    }

    this.createFilterCards();
    this.reloadTable(1);
  }
  createFilterCards() {
    this.selectedFilters = [];

    let selectedAreas = this.areas.filter((x) => x.checked);
    let selectedRegions = this.regions.filter((x) => x.checked);
    let selectedGeoRegions = this.geographicalRegions.filter((x) => x.checked);
    let selectedSubGeoRegions = this.subGeographicalRegions.filter(
      (x) => x.checked
    );
    let selectedStatusItems = this.statusItems.filter((x) => x.checked);
    this.selectedAreas = this.areas.filter((x) => x.checked).map((x) => x.id);
    this.selectedRegions = this.regions.filter((x) => x.checked).map((x) => x.id);
    this.selectedSubGeographicalRegions = selectedSubGeoRegions.map(
      (x) => x.id as number
    );
    this.selectedStatuses = selectedStatusItems.map((x) => x.id);
    //regions
    for (var i = 0; i < selectedRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(this.buName, selectedRegions[i].name)
      );
    }

    //geographical regions
    for (var i = 0; i < selectedGeoRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          'Geographical Region',
          selectedGeoRegions[i].name,
          'COMMON.GEOGRAPHICAL_REGION.SINGLE'
        )
      );
    }

    //areas
    for (var i = 0; i < selectedAreas.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(this.utName, selectedAreas[i].name)
      );
    }

    //sub geographical regions
    for (var i = 0; i < selectedSubGeoRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          'Sub Geographical Region',
          selectedSubGeoRegions[i].name,
          'COMMON.SUB_GEOGRAPHICAL_REGION.SINGLE'
        )
      );
    }

    //statuses
    for (var i = 0; i < selectedStatusItems.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem('Status', selectedStatusItems[i].name)
      );
    }

 //tag
    if (this.tag !== undefined) {
      var tagName = this.tagOptions[this.tag].name;
      this.selectedFilters.push(new ChecklistItem('Tag', tagName));
    }
  }
}
